import Header from "../components/site/Header";
import Footer from "../components/site/Footer";
import Globe from "../components/site/Globe";
import PageHero from "../components/site/PageHero";
import { CTABand } from "../components/site/ContentBlocks";
import { FadeUp } from "../components/site/Reveal";
import { ABOUT_NETWORK } from "../data/content";

export default function GlobalNetwork() {
    return (
        <div className="grain bg-navy-deep" data-testid="global-network-page">
            <Header />
            <main>
                <PageHero
                    seo={{
                        title: "Global Network | Mauritius, Vietnam, India, Thailand, China — Viet Medica Ltd",
                        description:
                            "Viet Medica Ltd works through international teams, representatives, providers and business partners across Mauritius, Vietnam, India, Thailand, China and wider markets.",
                        path: "/global-network",
                    }}
                    crumbs={[{ label: "Global Network" }]}
                    eyebrow="Global Network"
                    title="Based in Mauritius."
                    titleEm="Connected Worldwide."
                    copy="Viet Medica Ltd works through teams, representatives, agents, providers and business partners across different countries, languages and time zones. We combine local market understanding with international business experience to connect people, providers, products and opportunities."
                />

                <section className="bg-navy-deep py-20 lg:py-28" data-testid="global-network-regions">
                    <div className="mx-auto grid max-w-[1440px] grid-cols-1 items-center gap-14 px-5 lg:grid-cols-2 lg:px-10">
                        <FadeUp>
                            <Globe className="mx-auto h-auto w-full max-w-[480px]" />
                        </FadeUp>
                        <div>
                            {ABOUT_NETWORK.map((r, i) => (
                                <FadeUp key={r.name} delay={i * 0.06}>
                                    <div
                                        className="flex flex-col gap-1 border-t border-white/10 py-5 transition-colors duration-500 hover:border-gold/30 sm:flex-row sm:items-baseline sm:justify-between"
                                        data-testid={`network-page-${r.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                                    >
                                        <span className="font-serif text-xl font-normal text-ivory lg:text-2xl">{r.name}</span>
                                        <span className="text-xs uppercase tracking-[0.18em] text-gold/80">{r.role}</span>
                                    </div>
                                </FadeUp>
                            ))}
                            <div className="border-t border-white/10" aria-hidden="true" />
                            <FadeUp delay={0.2}>
                                <p className="mt-6 text-xs leading-relaxed tracking-wide text-slate-500">
                                    We work through teams, representatives and partners, and do not claim physical
                                    offices in markets where an office has not been confirmed.
                                </p>
                            </FadeUp>
                        </div>
                    </div>
                </section>

                <section className="bg-navy-surface py-20 lg:py-28">
                    <div className="mx-auto max-w-[1440px] px-5 lg:px-10">
                        <CTABand
                            title="Reach our international network."
                            primary={{ label: "Contact Us", to: "/contact", testid: "network-contact-cta" }}
                            secondary={{ label: "About Viet Medica", to: "/about", testid: "network-about-cta" }}
                        />
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    );
}
